import { ClientToServerPortalEventsType, ServerToClientPortalEventsType } from './contracts';
import { get as getPath } from 'lodash';
import RealtimeClient, {
  CreateRealtimeClientType,
  ClientEventHandlersTypes,
  StateCallbackType,
  ClientSocket
} from '@shared/core-realtime/client';

import {
  useStore,
  getGlobalFieldsSyncStatus,
  resetGlobalFields,
  setGlobalFieldsStaleSyncData,
  updateGlobalFieldWithSyncData,
  initializeGlobalFields,
  getRequiredLinkedFormData,
} from '@shared/core-library/src/globalStore';
import { listenToEvent } from '@shared/core-library/src/globalStore/events';
import { safeParseJSON } from '@shared/core-library/src/schema/utils';
// import { AvailabilityAsBlob } from '../../apps/sync-search-service/src/repositories/AvailabilityBlobRepository';

type PortalRealtimeClientType = {
  ping: () => void;
  login: (token: string) => void;
  authenticate: (token: string) => void;
  logout: () => void;
  onRouteChanged: () => void;
  onDeleteGlobalFieldValue: (globalFieldId: string, valueId: string) => void;
  isLoggedIn: () => boolean;
  // getAvailabilityData: (tagKey: string) => Promise<AvailabilityAsBlob['blob_data']>;
};

export type {
  ServerToClientPortalEventsType,
  ClientToServerPortalEventsType,
  PortalRealtimeClientType,
  CreateRealtimeClientType,
  StateCallbackType,
}

type SocketType = ClientSocket<ServerToClientPortalEventsType, ClientToServerPortalEventsType>;

// Map to track pending availability data requests
// const pendingAvailabilityRequests = new Map<string, {
//   resolve: (data: AvailabilityAsBlob['blob_data']) => void;
//   reject: (error: Error) => void;
// }>();

const clientEventHandlers: ClientEventHandlersTypes<ServerToClientPortalEventsType, ClientToServerPortalEventsType> = {
  onConnected: {
    handler: (socket: SocketType, message: string) => {
      socket.emit('getGlobalFieldsAutoComplete');
    }
  },
  onLoginSuccessful: {
    handler: (socket: SocketType) => {
      console.log('client received onLoginSuccessful');
      // alert('client received onLoginSuccessful');
      // socket.emit('getGlobalFieldsAutoComplete');
    }
  },
  welcome: {
    handler: (socket: SocketType, message: string) => {
      console.log(`Server: ${message}`);
      // alert(`Server: ${message}`);
    }
  },
  pong: {
    handler: (socket: SocketType) => {
      console.log('Server: ponged');
      // alert('Server: ponged');
    }
  },
  syncGlobalFieldsAutoComplete: {
    handler: function (socket: SocketType, fields: any): void {
      console.log('client received syncGlobalFieldsAutoComplete');

      // setGlobalFieldsStaleSyncData(fields);
      // const hasData =
      // const hasValues = Object.keys(newData).length > 0;
      // if (hasValues) {
      //   setGlobalFieldsStaleSyncData(fields);
      // } else {
      //   useStore.getState().setGlobalFieldsAutoSetGlobalFieldsAutoComplete(fields);
      //   useStore.getState().setGlobalFieldsSyncStatus('current');
      // }

      const sync = getGlobalFieldsSyncStatus();
      if (sync?.status === 'current' || sync?.status === 'stale') {
        setGlobalFieldsStaleSyncData(fields);
      } else if (sync?.status === 'uninitialized') {
        initializeGlobalFields(fields);
      }
    }
  },
  availabilityDataResponse: {
    handler: function (socket: SocketType, data: any): void {
      console.log('client received availabilityDataResponse.data.', data);
      if (!data) return;
      useStore.getState().setAvailabilityData(data);

      // console.log('client received availabilityDataResponse.data', data);
      // Find and resolve the pending request
      // for (const [tagKey, { resolve }] of pendingAvailabilityRequests.entries()) {
      //   resolve(data);
      //   pendingAvailabilityRequests.delete(tagKey);
      //   break; // Assuming one response per request for now
      // }
    }
  }
}

const createPortalRealtimeClient = (
  serverUrl: CreateRealtimeClientType<ServerToClientPortalEventsType, ClientToServerPortalEventsType>['serverUrl'],
  options: CreateRealtimeClientType<ServerToClientPortalEventsType, ClientToServerPortalEventsType>['options'],
  stateCallback: CreateRealtimeClientType<ServerToClientPortalEventsType, ClientToServerPortalEventsType>['stateCallback']
): PortalRealtimeClientType => {
  try {
    const client = new RealtimeClient<ServerToClientPortalEventsType, ClientToServerPortalEventsType>(
      serverUrl,
      clientEventHandlers,
      options,
      stateCallback
    )
    if (!client) {
      throw new Error('Failed to create client');
    }
    const portalRealtimeClient: PortalRealtimeClientType = {
      login: (token: string) => {
        console.log('client: login', client);
        resetGlobalFields();
        client.connect(token);
      },
      authenticate: (token: string) => {
        console.log('client: authenticated', client);
        client.connect(token);
      },
      logout: () => {
        client.disconnect();
        resetGlobalFields();
      },
      onRouteChanged: () => {
        const sync = getGlobalFieldsSyncStatus();
        console.log('onRouteChanged.sync', sync);
        if (sync?.status === 'stale') {
          updateGlobalFieldWithSyncData();
        }
      },
      onDeleteGlobalFieldValue: (globalFieldId: string, valueId: string) => {
        client.emit('removeGlobalFieldsValue', globalFieldId, valueId);
      },
      ping: (): void => {
        console.log('client: ping', client);

        console.log('Client: ping?');
        client.emit('ping');
      },
      isLoggedIn: () => client.isLoggedIn(),
      // getAvailabilityData: (tagKey: string): Promise<AvailabilityAsBlob['blob_data']> => {
      //   return new Promise((resolve, reject) => {
      //     // Store the promise resolvers
      //     pendingAvailabilityRequests.set(tagKey, { resolve, reject });
          
      //     // Send request to server
      //     client.emit('getAvailabilityData', tagKey);
          
      //     // Set a timeout to reject the promise if no response
      //     setTimeout(() => {
      //       if (pendingAvailabilityRequests.has(tagKey)) {
      //         pendingAvailabilityRequests.delete(tagKey);
      //         reject(new Error('Timeout waiting for availability data response'));
      //       }
      //     }, 5000); // 5 second timeout
      //   });
      // }
    } as PortalRealtimeClientType;

    listenToEvent('SUBMIT_SUCCESSFUL', (data) => {
      console.log('SUBMIT_SUCCESSFUL fired');
      console.log('SUBMIT_SUCCESSFUL data', data);
      console.log('SUBMIT_SUCCESSFUL.!portalRealtimeClient?.isLoggedIn()', !portalRealtimeClient?.isLoggedIn());
      if (!portalRealtimeClient?.isLoggedIn()) return;
      if (!data) return;
      client.emit('submitGlobalFieldChanges', data);
    });

    listenToEvent('SEARCH_AVAILABILITY', (data) => {
      console.log('SEARCH_AVAILABILITY fired');
      const { global_form_id } = data ?? {};
      if (!data || !global_form_id) return;
      console.log('SEARCH_AVAILABILITY data', data);

      const _requiredFormData = getRequiredLinkedFormData(global_form_id);
      const _requiredFormDataJson = safeParseJSON(_requiredFormData);

      const serviceType = getPath(_requiredFormDataJson, 'base_obj.service_type', null);
      const customerType = getPath(_requiredFormDataJson, 'base_obj.customer_type', null);
      if (!serviceType || !customerType) return;
      console.log('SEARCH_AVAILABILITY serviceType', serviceType);
      console.log('SEARCH_AVAILABILITY customerType', customerType);
      if (!portalRealtimeClient?.isLoggedIn()) return;
      console.log('SEARCH_AVAILABILITY.!portalRealtimeClient?.isLoggedIn()', !portalRealtimeClient?.isLoggedIn());
      const _tagKey = `${serviceType}.${customerType}`;
      client.emit('getAvailabilityData', _tagKey);
      // portalRealtimeClient.getAvailabilityData(`${customerNumber}.${customerType}`);
      // client.emit('getAvailabilityData', `${customerNumber}.${customerType}`);
    });

    listenToEvent('LOG_OUT', () => {
      console.log('LOG_OUT fired');
      if (!portalRealtimeClient?.isLoggedIn()) return;
      portalRealtimeClient?.logout();
    });

    return portalRealtimeClient;
  }
  catch (e) {
    throw new Error('Failed to create client');
  }
}

export default createPortalRealtimeClient;

